import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";

@Component({
  template: `
    <nb-checkbox [checked]="renderValue" status="info" disabled></nb-checkbox>
  `,
})
export class StbCustomRenderCheckboxComponent implements ViewCell, OnInit {
  renderValue: boolean = false;

  @Input() value: any;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = !this.value || this.value === "false" ? false : true;
  }
}
